import { render, staticRenderFns } from "./HistoryCreate.vue?vue&type=template&id=78337d62&scoped=true&"
import script from "./HistoryCreate.vue?vue&type=script&lang=js&"
export * from "./HistoryCreate.vue?vue&type=script&lang=js&"
import style0 from "./HistoryCreate.vue?vue&type=style&index=0&id=78337d62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78337d62",
  null
  
)

export default component.exports